import { render } from "./SaveTimesheetAction.vue?vue&type=template&id=208187c2"
import script from "./SaveTimesheetAction.vue?vue&type=script&lang=js"
export * from "./SaveTimesheetAction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__